module.exports = __webpack_public_path__ + "static/media/thumbnails_right.92551835.png";